import React, { useReducer } from 'react';
import { DataContext, initialState, reducer } from '../stores/crm-activity-store';

const CrmActivityContextWrapper = ({ children }) => {
    const [store, dispatch] = useReducer(reducer, initialState);

    return <DataContext.Provider value={{ store, dispatch }}>{children}</DataContext.Provider>;
};

export default CrmActivityContextWrapper;